import React from 'react'
import { Grid, TextField } from '@material-ui/core'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'


const filterOptions = createFilterOptions({
  matchFrom: 'any',
  limit: 100,
})

export const FormDadosEntrada = (props) => {
  const { values, touched, errors, currentUser, onChangeUser, onBlur } = props

  const getSetorLabel = (option) => {
    if (!option) return ''
    const nome = option.nome?.toUpperCase() || ''
    const sigla = option.sigla?.toUpperCase() || ''
    const regional = option.divisao?.regional?.nome?.toUpperCase() || ''
    return `${nome} - ${sigla} / ${regional}`
  }

  return (

    <Grid item md={12} sm={12} xs={12}>
      <Autocomplete
        value={values.setRec || null}
        name="setRec"
        filterOptions={filterOptions}
        noOptionsText="Sem informações"
        options={currentUser?.setores || []}
        onChange={(event, newValue) => onChangeUser('setRec', newValue)}
        onBlur={() => onBlur('setRec')}
        getOptionLabel={getSetorLabel}
        getOptionSelected={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Selecionar..."
            variant="outlined"
            label="SETOR DE ENTRADA ( UM DOS SEUS SETORES )"
            required
            InputLabelProps={{
              shrink: true,
            }}
            error={touched.setRec && !!errors.setRec}
            helperText={touched.setRec && errors.setRec ? errors.setRec : null}
          />
        )}
      />
    </Grid>

  )
}
